angular.module('elogbooksFilters').filter('trusted',  function($sce) {
    return function(value) {
      return $sce.trustAsHtml(value);
    };
});